import React from "react";
import HeaderDescription from "../../../components/commons/HeaderDescription";
import VendorSelectionCard from "./VendorSelectionCard";
import { RATE_ANALYSIS_VENDORS } from "./vendorData";

const VendorSelection = () => {
  return (
    <div className="rate-analysis-page">
      <HeaderDescription
        heading="Rate Analysis"
        description="Select a platform to compare service levels and vendor pricing for airport transfers."
      />

      <div className="rate-analysis-vendor-selection">
        <div className="rate-analysis-vendor-selection-header">
          <h2 className="font-16 font-600 m-0">Select Platform</h2>
          <p className="font-12 text-light-grey m-0">
            Choose which integration you want to run rate analysis for
          </p>
        </div>

        <div className="rate-analysis-vendor-card-grid">
          {RATE_ANALYSIS_VENDORS.map((vendor) => (
            <VendorSelectionCard key={vendor.id} vendor={vendor} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VendorSelection;
